// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
})();


(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();




//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq,index) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });
        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });
        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);
        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
        }
        event.currentTarget.classList.add('active-tab');
        const sliderOptions_faq = document.querySelector('.faq-wrapper .tabs-wrappper-main').getAttribute('data-slider-options');
        if (sliderOptions_faq){
          const slideroptionConfig_faq = JSON.parse(sliderOptions_faq);
          const faq_swiper = new Swiper(".faq-wrapper .tabs-wrappper-main", slideroptionConfig_faq);
          console.log(slideroptionConfig_faq,'slideroptionConfig_faq');
          faq_swiper.slideTo(index);
        }
        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });
    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end






//product tab
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      buttons.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});


//tab Featured collection
document.addEventListener("DOMContentLoaded", function () {
  const tabNavItems = document.querySelectorAll(".tab-nav-title");
  const tabContents = document.querySelectorAll(".tabs-content-wrapper");

  if (tabNavItems.length && tabContents.length) {
    tabNavItems[0].classList.add("active");
    tabContents[0].style.display = "block";
    for (let i = 1; i < tabContents.length; i++) {
      tabContents[i].style.display = "none";
    }
    tabNavItems.forEach((tab, index) => {
      const link = tab.querySelector("a");
      if (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          tabNavItems.forEach(t => {
            t.classList.remove("active");
          });
          tabContents.forEach(content => content.style.display = "none");
          tab.classList.add("active");
          if (tabContents[index]) {
            tabContents[index].style.display = "block";
          }
        });
      }
    });
  }
});


// header menu close icon trigger
document.querySelector('.header-menus-close').addEventListener('click', function() {
  let menuIcon = document.querySelector('.header__icon.header__icon--menu');
  if (menuIcon) { 
    menuIcon.click();
  }
});


// description popup open/close
// document.addEventListener('DOMContentLoaded', function () {
//   const button = document.querySelector('.popup-button');
//   const popup = document.querySelector('.popup-content');
//   const section = document.querySelector('.custom-tabs-section');

//   if (!button || !popup || !section) return;

//   button.addEventListener('click', function (e) {
//     e.stopPropagation();

//     const isOpen = popup.classList.toggle('active');

//     section.classList.toggle('popup-open', isOpen);
//     document.body.classList.toggle('overflow-hidden', isOpen);
//   });

//   popup.addEventListener('click', function (e) {
//     e.stopPropagation();
//   });

//   document.addEventListener('click', function () {
//     popup.classList.remove('active');
//     section.classList.remove('popup-open');
//     document.body.classList.remove('overflow-hidden');
//   });
// });

//checkout check
document.addEventListener('click', function(e) {
  const checkoutBtn = e.target.closest(
    'button[name="checkout"], .cart__checkout-button, #checkout'
  );
  if (!checkoutBtn) return;
  const checkbox = document.querySelector('#personalized-terms');
  if (!checkbox) return;
  if (!checkbox.checked) {
    e.preventDefault();
    e.stopImmediatePropagation();
    alert('Bitte bestätigen Sie zuerst die Checkbox.');
    return false;
  }

}, true);

// document.addEventListener('DOMContentLoaded', function () {

//   const checkbox = document.querySelector('#personalized-terms');
//   const checkoutBtn = document.querySelector(
//     'button[name="checkout"], .cart__checkout-button'
//   );

//   if (!checkbox || !checkoutBtn) return;

//   checkoutBtn.disabled = true;

//   checkbox.addEventListener('change', function () {
//     checkoutBtn.disabled = !this.checked;
//   });

// });

//image input label name change
// document.addEventListener('DOMContentLoaded', function () {
//   const fileInput = document.getElementById('style_mockup');
//   const fileName = document.getElementById('style_mockup_name');

//   if (!fileInput || !fileName) return;

//   fileInput.addEventListener('change', function () {
//     if (this.files.length === 0) {
//       fileName.textContent = '';
//       return;
//     }

//     if (this.files.length === 1) {
//       fileName.textContent = this.files[0].name;
//     } else {
//       fileName.textContent = this.files.length + ' Dateien ausgewählt';
//     }
//   });
// });
